import Lottie from 'lottie-react';

import animationUpload from '@assets/lottie-animation/lock.json';

export const NoAccessAccountGroup = () => {
  return (
    <div className="pb-6">
      <div className="grid min-h-full place-items-center rounded-xl border bg-white px-6 py-24 sm:py-10 lg:px-8">
        <div className="text-center">
          <h3 className="mt-4 text-3xl font-medium tracking-tight text-gray-900 sm:text-5xl">
            Access Restricted
          </h3>
          <p className="mx-auto mt-6 w-[500px] text-base leading-7 font-light text-gray-600">
            You don't have permission to access this page. This section is only available for
            authorized business groups.
          </p>

          <Lottie className="mx-auto mt-4 w-[400px]" animationData={animationUpload} loop={true} />

          <div className="space-y-3">
            <p className="text-sm text-gray-700">
              If you believe this is a mistake, please contact our support team for further
              assistance.
            </p>
            <p className="text-sm text-gray-700">
              💬 If you have any questions, feel free to contact our customer service.
            </p>
          </div>

          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a href="/" className="flex flex-col text-sm font-medium text-gray-900">
              <span aria-hidden="true">Contact support</span>
              <span aria-hidden="true">hello@doitpay.co</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
